import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./LoadingSpinner.css";

const LoadingSpinner = ({
  message = "Preparing your dashboard experience...",
  subMessage = "Loading all resources for a seamless experience",
}) => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner">
        <div className="spinner-container">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            size="3x"
            className="spinner-icon"
          />
          <div className="spinner-orbits">
            <div className="orbit orbit-1"></div>
            <div className="orbit orbit-2"></div>
            <div className="orbit orbit-3"></div>
          </div>
        </div>

        <div className="spinner-content">
          <h3 className="spinner-title">Welcome to DEA School Management</h3>
          <p className="spinner-message">{message}</p>
          <p className="spinner-submessage">{subMessage}</p>

          <div className="loading-progress">
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
            <div className="progress-stats">
              <span className="stat">Loading Images</span>
              <span className="stat">Preparing Data</span>
              <span className="stat">Optimizing Performance</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
